import styled, { css } from 'styled-components'
import { tokens } from 'styling/tokens'
import { OpsHorizonBlockKind } from 'types/operationsControl.interface'

const laneGrid = css`
  display: grid;
  grid-template-columns: 11rem 1fr;
  column-gap: 1rem;
  align-items: center;
`

const hourGridlines = css`
  background-image: linear-gradient(to right, ${tokens.border.hairline} 1px, transparent 1px);
  background-size: calc(100% / 6) 100%;
`

const kindStyle = ($kind: OpsHorizonBlockKind) => {
  switch ($kind) {
    case 'active':
      return css`
        background: ${tokens.status.success.bg};
        color: ${tokens.status.success.fg};
        border: 1px solid ${tokens.status.success.fg};
      `
    case 'assigned':
      return css`
        background: ${tokens.accent.soft};
        color: ${tokens.accent.base};
        border: 1px solid ${tokens.accent.base};
      `
    case 'proposed':
      return css`
        background: ${tokens.surface.inset};
        color: ${tokens.text.muted};
        border: 1px dashed ${tokens.border.hairline};
      `
    case 'blocked':
      return css`
        background: ${tokens.status.danger.bg};
        color: ${tokens.status.danger.fg};
        border: 1px solid ${tokens.status.danger.fg};
      `
  }
}

export const BoardWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const RulerRow = styled.div`
  ${laneGrid};
`

export const RulerSpacer = styled.div``

export const RulerTrack = styled.div`
  position: relative;
  height: 1.5rem;
  border-bottom: 1px solid ${tokens.border.hairline};
  ${hourGridlines};
`

export const RulerTick = styled.span<{ $index: number }>`
  position: absolute;
  bottom: 0.25rem;
  left: ${({ $index }) => ($index / 6) * 100}%;
  transform: ${({ $index }) =>
    $index === 0 ? 'none' : $index === 6 ? 'translateX(-100%)' : 'translateX(-50%)'};
  font-size: ${tokens.font.micro};
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
  white-space: nowrap;
`

export const LaneRow = styled.div`
  ${laneGrid};
`

export const LaneLabel = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const ResourceTag = styled.span`
  font-size: ${tokens.font.micro};
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
`

export const LaneTrack = styled.div`
  position: relative;
  height: 3rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  ${hourGridlines};
`

export const BlockChip = styled.div<{ $kind: OpsHorizonBlockKind; $left: number; $width: number }>`
  position: absolute;
  top: 50%;
  margin-top: -1.125rem;
  height: 2.25rem;
  left: ${({ $left }) => $left}%;
  width: ${({ $width }) => $width}%;
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  border-radius: ${tokens.radius.chip};
  font-size: ${tokens.font.micro};
  font-weight: 600;
  cursor: default;
  transition: transform ${tokens.motion.duration} ${tokens.motion.ease},
    box-shadow ${tokens.motion.duration} ${tokens.motion.ease};
  ${({ $kind }) => kindStyle($kind)};

  &:hover {
    transform: scaleY(1.08);
    box-shadow: ${tokens.shadow.card};
    z-index: 1;
  }
`

export const BlockLabel = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const LegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-top: 1rem;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const LegendSwatch = styled.span<{ $kind: OpsHorizonBlockKind }>`
  width: 1rem;
  height: 0.75rem;
  border-radius: 4px;
  ${({ $kind }) => kindStyle($kind)};
`

export const EmptyStateWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 3rem 2rem;
  text-align: center;
`
